import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export function ExitIntentPopup() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    if (sessionStorage.getItem('exit_intent_shown')) return;
    const showPopup = () => {
      setIsVisible(true);
      sessionStorage.setItem('exit_intent_shown', 'true');
    };
    const handleMouseLeave = (e: MouseEvent) => {
      if (e.clientY <= 0) {
        showPopup();
      }
    };
    const isMobile = window.innerWidth < 768;
    let mobileTimer: NodeJS.Timeout;
    if (isMobile) {
      mobileTimer = setTimeout(showPopup, 45000);
    } else {
      document.addEventListener('mouseleave', handleMouseLeave);
    }
    return () => {
      document.removeEventListener('mouseleave', handleMouseLeave);
      if (mobileTimer) clearTimeout(mobileTimer);
    };
  }, []);
  const scrollToCheckout = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsVisible(false);
    setTimeout(() => {
      document.getElementById('checkout')?.scrollIntoView({
        behavior: 'smooth'
      });
    }, 200);
  };
  return <AnimatePresence data-id="element-149">
      {isVisible && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-ink/60 backdrop-blur-md" data-id="element-150">
          <motion.div initial={{
        scale: 0.92,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} exit={{
        scale: 0.92,
        opacity: 0
      }} className="bg-cream rounded-3xl shadow-2xl max-w-md w-full p-6 md:p-8 relative border-2 border-gold/40" data-id="element-151">
            <button onClick={() => setIsVisible(false)} aria-label="Cerrar" className="absolute top-4 right-4 text-ink/40 hover:text-primary transition-colors bg-white/80 rounded-full p-1" data-id="element-152">
              <X size={20} data-id="element-153" />
            </button>

            <div className="text-center pt-2" data-id="element-154">
              <h3 className="font-serif font-bold text-2xl md:text-3xl text-primary mb-4 leading-tight" data-id="element-155">
                ⏳ Espera… si llegaste hasta aquí, una parte de ti ya sabe que
                necesita cerrar este ciclo.
              </h3>
              <p className="text-ink/80 text-sm md:text-base mb-6 font-sans" data-id="element-156">
                No te vayas sin dar el primer paso. Hoy aún puedes acceder a{' '}
                <span className="font-bold text-primary" data-id="element-157">
                  EL CÓDIGO DEL CIERRE™
                </span>{' '}
                con todos los bonos por solo{' '}
                <span className="font-extrabold text-accent" data-id="element-158">$6.99 USD</span>.
                Esta oferta no estará disponible siempre.
              </p>

              <a href="#checkout" onClick={scrollToCheckout} className="block w-full bg-gradient-to-br from-accent to-primary text-white font-extrabold py-4 px-6 rounded-full shadow-[0_6px_0_#3A1D2C,0_10px_20px_rgba(92,46,70,0.4)] hover:-translate-y-0.5 active:translate-y-1 active:shadow-[0_2px_0_#3A1D2C] transition-all text-sm md:text-base mb-4 tracking-wide" data-id="element-159">
                ✨ QUIERO APROVECHAR ESTA OPORTUNIDAD
              </a>

              <button onClick={() => setIsVisible(false)} className="text-xs md:text-sm text-ink/50 underline hover:text-ink transition-colors" data-id="element-160">
                No, prefiero seguir como estoy
              </button>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}